import "react-toastify/dist/ReactToastify.css";

import { Route, Routes } from "react-router-dom";
import { Home } from "./Pages";
import { Footer, Header } from "./components";

import { AnimatePresence } from "framer-motion";
import { ToastContainer } from "react-toastify";
import { AppProvider } from "./context/AppContext";
import ProductDetail from "./Pages/ProductDetail";

import "swiper/css";
import "swiper/css/navigation";

function App() {
  return (
    <AnimatePresence exitBeforeEnter>
      <AppProvider>
        <ToastContainer />
        <div className="w-screen h-auto min-h-[100vh] flex flex-col bg-primary">
          <Header />
          <main
            className="w-full h-auto min-h-[calc(100vh-64px)] flex flex-col px-3 py-4 mt-16 md:mt-16 md:px-8 md:py-6"
            onClick={() => {}}
          >
            {/* Routes */}
            <Routes>
              <Route path="/*" element={<Home />} />
              <Route path="/products/:code" element={<ProductDetail />} />
            </Routes>

            <Footer />
          </main>
        </div>
      </AppProvider>
    </AnimatePresence>
  );
}

export default App;
